/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AccessTokenError } from '../model/accessTokenError';
import { ErrorMessage } from '../model/errorMessage';
import { GroupAssignRequestInfo } from '../model/groupAssignRequestInfo';
import { GroupAssignResponseInfo } from '../model/groupAssignResponseInfo';
import { ReportConfigReportResponseInfoList } from '../model/reportConfigReportResponseInfoList';
import { ReportConfigReportResponseInfoList2 } from '../model/reportConfigReportResponseInfoList2';
import { ReportConfigReportResponseInfoList3 } from '../model/reportConfigReportResponseInfoList3';
import { ReportConfigReportResponseInfoList4 } from '../model/reportConfigReportResponseInfoList4';
import { ReportConfigRequestInfo } from '../model/reportConfigRequestInfo';
import { ReportConfigRequestInfo2 } from '../model/reportConfigRequestInfo2';
import { ReportConfigRequestInfo3 } from '../model/reportConfigRequestInfo3';
import { ReportConfigRequestInfo4 } from '../model/reportConfigRequestInfo4';
import { ReportCreateRequestInfo } from '../model/reportCreateRequestInfo';
import { ReportCreateRequestInfo2 } from '../model/reportCreateRequestInfo2';
import { ReportResponseInfo } from '../model/reportResponseInfo';
import { ReportResponseInfo2 } from '../model/reportResponseInfo2';
import { ReportResponseInfoList } from '../model/reportResponseInfoList';
import { RequestInfo } from '../model/requestInfo';
import { StandardUserReportResponseInfoList } from '../model/standardUserReportResponseInfoList';
import { StarredReportRequest } from '../model/starredReportRequest';
import { StarredReportResponse } from '../model/starredReportResponse';
import { StatusRequestInfo } from '../model/statusRequestInfo';
import { StatusResponseInfo } from '../model/statusResponseInfo';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ReportMgrService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * OrgMgr_ReportMgr_StandardReportAssignment, Assign group to report
     * Assign group to report
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1GroupReportAssignmentPut(GroupId: number, Request: GroupAssignRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<GroupAssignResponseInfo>;
    public orgMgrReportMgrV1GroupReportAssignmentPut(GroupId: number, Request: GroupAssignRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GroupAssignResponseInfo>>;
    public orgMgrReportMgrV1GroupReportAssignmentPut(GroupId: number, Request: GroupAssignRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GroupAssignResponseInfo>>;
    public orgMgrReportMgrV1GroupReportAssignmentPut(GroupId: number, Request: GroupAssignRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrReportMgrV1GroupReportAssignmentPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrReportMgrV1GroupReportAssignmentPut.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<GroupAssignResponseInfo>(`${this.basePath}/OrgMgr/ReportMgr/V1/Group/Report/Assignment`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_RetrieveStandardReport, Retrieve standard report
     * Retrieve standard report
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1GroupStandardReportGet(GroupId?: number, observe?: 'body', reportProgress?: boolean): Observable<ReportResponseInfoList>;
    public orgMgrReportMgrV1GroupStandardReportGet(GroupId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReportResponseInfoList>>;
    public orgMgrReportMgrV1GroupStandardReportGet(GroupId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReportResponseInfoList>>;
    public orgMgrReportMgrV1GroupStandardReportGet(GroupId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ReportResponseInfoList>(`${this.basePath}/OrgMgr/ReportMgr/V1/Group/StandardReport`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_DeleteStandardReport,  Delete the requested StandardReport
     * Delete the requested StandardReport
     * @param StandardReportId Enter the Id for which StandardReport needs to be deleted
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1GroupStandardReportStandardReportIdDelete(StandardReportId: number, GroupId?: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrReportMgrV1GroupStandardReportStandardReportIdDelete(StandardReportId: number, GroupId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public orgMgrReportMgrV1GroupStandardReportStandardReportIdDelete(StandardReportId: number, GroupId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public orgMgrReportMgrV1GroupStandardReportStandardReportIdDelete(StandardReportId: number, GroupId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (StandardReportId === null || StandardReportId === undefined) {
            throw new Error('Required parameter StandardReportId was null or undefined when calling orgMgrReportMgrV1GroupStandardReportStandardReportIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/ReportMgr/V1/Group/StandardReport/${encodeURIComponent(String(StandardReportId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_UpdateStandardReport, Update a StandardReport
     * Update a StandardReport
     * @param StandardReportId Enter the Id for which StandardReport needs to be updated
     * @param Request Enter the request values
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1GroupStandardReportStandardReportIdPut(StandardReportId: number, Request: ReportCreateRequestInfo2, GroupId?: number, observe?: 'body', reportProgress?: boolean): Observable<ReportResponseInfo2>;
    public orgMgrReportMgrV1GroupStandardReportStandardReportIdPut(StandardReportId: number, Request: ReportCreateRequestInfo2, GroupId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReportResponseInfo2>>;
    public orgMgrReportMgrV1GroupStandardReportStandardReportIdPut(StandardReportId: number, Request: ReportCreateRequestInfo2, GroupId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReportResponseInfo2>>;
    public orgMgrReportMgrV1GroupStandardReportStandardReportIdPut(StandardReportId: number, Request: ReportCreateRequestInfo2, GroupId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (StandardReportId === null || StandardReportId === undefined) {
            throw new Error('Required parameter StandardReportId was null or undefined when calling orgMgrReportMgrV1GroupStandardReportStandardReportIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrReportMgrV1GroupStandardReportStandardReportIdPut.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<ReportResponseInfo2>(`${this.basePath}/OrgMgr/ReportMgr/V1/Group/StandardReport/${encodeURIComponent(String(StandardReportId))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_StatusStandardReport, Update status on standard report
     * Update status on standard report
     * @param StandardReportId Enter the Id for which StandardReport needs to be updated
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1GroupStandardReportStandardReportIdStatusPost(StandardReportId: number, GroupId: number, Request: StatusRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<StatusResponseInfo>;
    public orgMgrReportMgrV1GroupStandardReportStandardReportIdStatusPost(StandardReportId: number, GroupId: number, Request: StatusRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StatusResponseInfo>>;
    public orgMgrReportMgrV1GroupStandardReportStandardReportIdStatusPost(StandardReportId: number, GroupId: number, Request: StatusRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StatusResponseInfo>>;
    public orgMgrReportMgrV1GroupStandardReportStandardReportIdStatusPost(StandardReportId: number, GroupId: number, Request: StatusRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (StandardReportId === null || StandardReportId === undefined) {
            throw new Error('Required parameter StandardReportId was null or undefined when calling orgMgrReportMgrV1GroupStandardReportStandardReportIdStatusPost.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrReportMgrV1GroupStandardReportStandardReportIdStatusPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrReportMgrV1GroupStandardReportStandardReportIdStatusPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<StatusResponseInfo>(`${this.basePath}/OrgMgr/ReportMgr/V1/Group/StandardReport/${encodeURIComponent(String(StandardReportId))}/Status`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_DeleteUserReport, Delete the requested user report
     * Delete the requested user report
     * @param UserReportId Enter the Id for which User Report needs to be deleted
     * @param UserId Enter the UserId
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1GroupUserReportUserReportIdDelete(UserReportId: number, UserId: number, GroupId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public orgMgrReportMgrV1GroupUserReportUserReportIdDelete(UserReportId: number, UserId: number, GroupId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public orgMgrReportMgrV1GroupUserReportUserReportIdDelete(UserReportId: number, UserId: number, GroupId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public orgMgrReportMgrV1GroupUserReportUserReportIdDelete(UserReportId: number, UserId: number, GroupId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (UserReportId === null || UserReportId === undefined) {
            throw new Error('Required parameter UserReportId was null or undefined when calling orgMgrReportMgrV1GroupUserReportUserReportIdDelete.');
        }
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrReportMgrV1GroupUserReportUserReportIdDelete.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrReportMgrV1GroupUserReportUserReportIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/OrgMgr/ReportMgr/V1/Group/UserReport/${encodeURIComponent(String(UserReportId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_RetrieveReportConfig, Get report config for StandardReport or UserReport
     * Get report config for StandardReport or UserReport
     * @param UserId Enter the UserId
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1ReportConfigPost(UserId: number, GroupId: number, Request: ReportConfigRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<ReportConfigReportResponseInfoList>;
    public orgMgrReportMgrV1ReportConfigPost(UserId: number, GroupId: number, Request: ReportConfigRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReportConfigReportResponseInfoList>>;
    public orgMgrReportMgrV1ReportConfigPost(UserId: number, GroupId: number, Request: ReportConfigRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReportConfigReportResponseInfoList>>;
    public orgMgrReportMgrV1ReportConfigPost(UserId: number, GroupId: number, Request: ReportConfigRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrReportMgrV1ReportConfigPost.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrReportMgrV1ReportConfigPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrReportMgrV1ReportConfigPost.');
        }

        let headers = this.defaultHeaders;
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ReportConfigReportResponseInfoList>(`${this.basePath}/OrgMgr/ReportMgr/V1/Report/Config`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_RetrieveReportData, Get report data
     * Get report data
     * @param UserId Enter the UserId
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1ReportDataPost(UserId: number, GroupId: number, Request: ReportConfigRequestInfo2, observe?: 'body', reportProgress?: boolean): Observable<ReportConfigReportResponseInfoList2>;
    public orgMgrReportMgrV1ReportDataPost(UserId: number, GroupId: number, Request: ReportConfigRequestInfo2, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReportConfigReportResponseInfoList2>>;
    public orgMgrReportMgrV1ReportDataPost(UserId: number, GroupId: number, Request: ReportConfigRequestInfo2, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReportConfigReportResponseInfoList2>>;
    public orgMgrReportMgrV1ReportDataPost(UserId: number, GroupId: number, Request: ReportConfigRequestInfo2, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrReportMgrV1ReportDataPost.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrReportMgrV1ReportDataPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrReportMgrV1ReportDataPost.');
        }

        let headers = this.defaultHeaders;
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ReportConfigReportResponseInfoList2>(`${this.basePath}/OrgMgr/ReportMgr/V1/Report/Data`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_DownloadReport, Download the report
     * Download the report
     * @param UserId Enter the UserId
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param DownloadType Select the DownloadType. Allowed values are AllColumns, MappedColumns
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1ReportDownloadPost(UserId: number, GroupId: number, Request: RequestInfo, DownloadType?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public orgMgrReportMgrV1ReportDownloadPost(UserId: number, GroupId: number, Request: RequestInfo, DownloadType?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public orgMgrReportMgrV1ReportDownloadPost(UserId: number, GroupId: number, Request: RequestInfo, DownloadType?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public orgMgrReportMgrV1ReportDownloadPost(UserId: number, GroupId: number, Request: RequestInfo, DownloadType?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrReportMgrV1ReportDownloadPost.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrReportMgrV1ReportDownloadPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrReportMgrV1ReportDownloadPost.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (DownloadType !== undefined) {
            queryParameters = queryParameters.set('DownloadType', <any>DownloadType);
        }

        let headers = this.defaultHeaders;
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/csv'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/OrgMgr/ReportMgr/V1/Report/Download`,
            Request,
            {
                params: queryParameters,
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_SaveReport, Save a report
     * Save a report
     * @param UserId Enter the UserId
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1ReportSavePut(UserId: number, GroupId: number, Request: ReportConfigRequestInfo3, observe?: 'body', reportProgress?: boolean): Observable<ReportConfigReportResponseInfoList3>;
    public orgMgrReportMgrV1ReportSavePut(UserId: number, GroupId: number, Request: ReportConfigRequestInfo3, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReportConfigReportResponseInfoList3>>;
    public orgMgrReportMgrV1ReportSavePut(UserId: number, GroupId: number, Request: ReportConfigRequestInfo3, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReportConfigReportResponseInfoList3>>;
    public orgMgrReportMgrV1ReportSavePut(UserId: number, GroupId: number, Request: ReportConfigRequestInfo3, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrReportMgrV1ReportSavePut.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrReportMgrV1ReportSavePut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrReportMgrV1ReportSavePut.');
        }

        let headers = this.defaultHeaders;
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<ReportConfigReportResponseInfoList3>(`${this.basePath}/OrgMgr/ReportMgr/V1/Report/Save`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_ShareReport, Share the report
     * Share the report
     * @param UserId Enter the UserId
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1ReportSharePost(UserId: number, GroupId: number, Request: ReportConfigRequestInfo4, observe?: 'body', reportProgress?: boolean): Observable<ReportConfigReportResponseInfoList4>;
    public orgMgrReportMgrV1ReportSharePost(UserId: number, GroupId: number, Request: ReportConfigRequestInfo4, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReportConfigReportResponseInfoList4>>;
    public orgMgrReportMgrV1ReportSharePost(UserId: number, GroupId: number, Request: ReportConfigRequestInfo4, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReportConfigReportResponseInfoList4>>;
    public orgMgrReportMgrV1ReportSharePost(UserId: number, GroupId: number, Request: ReportConfigRequestInfo4, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrReportMgrV1ReportSharePost.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrReportMgrV1ReportSharePost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrReportMgrV1ReportSharePost.');
        }

        let headers = this.defaultHeaders;
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ReportConfigReportResponseInfoList4>(`${this.basePath}/OrgMgr/ReportMgr/V1/Report/Share`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_StarredReport, Starred a report
     * Starred a report
     * @param GroupId Enter the GroupId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1ReportStarredPost(GroupId: number, Request: StarredReportRequest, observe?: 'body', reportProgress?: boolean): Observable<StarredReportResponse>;
    public orgMgrReportMgrV1ReportStarredPost(GroupId: number, Request: StarredReportRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StarredReportResponse>>;
    public orgMgrReportMgrV1ReportStarredPost(GroupId: number, Request: StarredReportRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StarredReportResponse>>;
    public orgMgrReportMgrV1ReportStarredPost(GroupId: number, Request: StarredReportRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrReportMgrV1ReportStarredPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrReportMgrV1ReportStarredPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<StarredReportResponse>(`${this.basePath}/OrgMgr/ReportMgr/V1/Report/Starred`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_CreateReport, Create a Report
     * Create a Report
     * @param Request Enter the request values
     * @param GroupId Enter the GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1StandardReportPost(Request: ReportCreateRequestInfo, GroupId?: number, observe?: 'body', reportProgress?: boolean): Observable<ReportResponseInfo>;
    public orgMgrReportMgrV1StandardReportPost(Request: ReportCreateRequestInfo, GroupId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReportResponseInfo>>;
    public orgMgrReportMgrV1StandardReportPost(Request: ReportCreateRequestInfo, GroupId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReportResponseInfo>>;
    public orgMgrReportMgrV1StandardReportPost(Request: ReportCreateRequestInfo, GroupId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling orgMgrReportMgrV1StandardReportPost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ReportResponseInfo>(`${this.basePath}/OrgMgr/ReportMgr/V1/StandardReport`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * OrgMgr_ReportMgr_Retrieve_Standard_UserReport, Retrieve Standard or User report
     * Retrieve Standard or User report
     * @param UserId Enter the UserId
     * @param GroupId Enter the GroupId
     * @param IsStarred Is report Starred?
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public orgMgrReportMgrV1UserReportGet(UserId: number, GroupId: number, IsStarred?: string, observe?: 'body', reportProgress?: boolean): Observable<StandardUserReportResponseInfoList>;
    public orgMgrReportMgrV1UserReportGet(UserId: number, GroupId: number, IsStarred?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StandardUserReportResponseInfoList>>;
    public orgMgrReportMgrV1UserReportGet(UserId: number, GroupId: number, IsStarred?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StandardUserReportResponseInfoList>>;
    public orgMgrReportMgrV1UserReportGet(UserId: number, GroupId: number, IsStarred?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (UserId === null || UserId === undefined) {
            throw new Error('Required parameter UserId was null or undefined when calling orgMgrReportMgrV1UserReportGet.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling orgMgrReportMgrV1UserReportGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (IsStarred !== undefined) {
            queryParameters = queryParameters.set('IsStarred', <any>IsStarred);
        }

        let headers = this.defaultHeaders;
        if (UserId !== undefined && UserId !== null) {
            headers = headers.set('UserId', String(UserId));
        }
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<StandardUserReportResponseInfoList>(`${this.basePath}/OrgMgr/ReportMgr/V1/User/Report`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
